import { LuX } from 'react-icons/lu'

import { StopsCountCell } from '../StopsCountCell'
import cellStyles from '../TaskCellPopout.module.css'
import { TaskTripDetails } from '../TaskTripDetails'
import styles from './TaskStopsPopout.module.css'
import { TaskStopsPopoutProps } from './TaskStopsPopout.types'
import { useTaskStopsPopout } from './useTaskStopsPopout'

const SKELETON_ROW_COUNT = 4

// Mimics TaskTripDetails' row shape (circle + card) and fills the same height, so opening the
// popout doesn't resize once real data arrives.
const TripDetailsSkeleton = () => (
  <div className={styles.skeletonTimeline}>
    {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
      <div className={styles.skeletonRow} key={index}>
        <div className={styles.skeletonCircle} />
        <div className={styles.skeletonCard} />
      </div>
    ))}
  </div>
)

export const TaskStopsPopout = ({ task, count, testId }: TaskStopsPopoutProps) => {
  const computedTestId = testId ?? `task-stops-popout-${task.taskDefinition.id}`
  const {
    buttonRef,
    dialogRef,
    progress,
    isLoadingProgress,
    hasProgressError,
    showPopover,
    closePopover,
  } = useTaskStopsPopout(task)

  return (
    <div data-testid={computedTestId}>
      <StopsCountCell
        ref={buttonRef}
        count={count}
        onClick={showPopover}
        testId={`${computedTestId}-trigger`}
      />

      <dialog
        id={`task-stops-dialog-${task.taskDefinition.id}`}
        ref={dialogRef}
        className={`${cellStyles.popoutContainer} ${styles.dialog}`}
        popover="auto"
      >
        <div className={styles.header}>
          <span className={styles.title}>Trip Details</span>
          <button
            type="button"
            className={cellStyles.actionButton}
            data-testid={`${computedTestId}-close`}
            onClick={closePopover}
          >
            <LuX size={16} />
          </button>
        </div>

        <div className={styles.body}>
          {isLoadingProgress && (
            <div className={styles.loading} data-testid={`${computedTestId}-loading`}>
              <TripDetailsSkeleton />
            </div>
          )}

          {!isLoadingProgress && hasProgressError && (
            <div className={styles.error} data-testid={`${computedTestId}-error`}>
              Failed to load stop details. Please try again.
            </div>
          )}

          {!isLoadingProgress && !hasProgressError && progress && (
            <TaskTripDetails progress={progress} locations={task.taskDefinition.locations} />
          )}
        </div>
      </dialog>
    </div>
  )
}
